import React, {useEffect, useState} from "react";
import {Switch, Redirect} from "react-router-dom";
import config from "../../../settings"


export default function AuthorizePage() {


    const [isLoading, setLoading] = useState(true);

    window.sessionStorage.setItem("ingressPath", window.location.pathname);

    useEffect(() => {
                
        // Costruisco chiamata verso Authorize endpoint
        //var authorizeUrl = config.baseIdpUrl + config.authorize + "?authenticationClientCode=" + config.clientCode;
        var authorizeUrl = config.baseIdpUrl + "?SAMLRequest=" +  config.samlrequest; //process.env.SAMLREQUEST; 

        window.location.href = authorizeUrl;

    }, []);

    if (isLoading) {
        return <div className="App">Loading...</div>;
      }

    return (
        <>
            <Switch>
                <Redirect to="/authorize"/>
            </Switch>
            <div className="loading-container"></div>
            <div className="loading-widget"><div className="loading-img"></div></div>
        </>

    );
}
